import React from 'react'
import NavBar from '../NavBar';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import SearchIcon from "@mui/icons-material/Search";
import { WareCardData as data } from '../WarehouseDetailsCardData';


const WarehouseDetails = () => {
  return (
    <div>
      <NavBar />
        <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Human Resource Management </span>
          <span className="color"> &#62; </span>
          <span className="color"> Warehouse Details </span>
        </p>
      </div>
        <div id="Right-content-Down-First" style={{marginTop:'16px'}}>
          <h1>Warehouse</h1>
          <div style={{ display: "flex", gap: "6px" }}>
          <div className="create-team"
            style={{
              width:'13rem',
              backgroundColor:'#4E6DCB'
            }}
          >
          <span style={{paddingTop:'1px'}}>
          <AddCircleOutlineIcon />
          </span>
           <div >Add a warehouse</div>
          </div>
          <div id="Right-content-Down-Filters">
            {/* <div
              style={{
                "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
                height: "80%",
              }}
            ></div> */}
            <MoreVertIcon />
          </div>
        </div>
        </div>
        <div className="warehouse-details-table">
        <div id="click-data">
              <p>All Warehouses</p>
              <p>Recently Added</p>
            </div>
            <div className="order-list-input-box" id='warehouse-detail'>
          <div className="order-list-input-left">
            <input
              type="text"
              placeholder="Search by invoice ID, category"
            //   onChange={(val) => {
            //     setCount(
            //       ACCOUNTTRANSACTIONSTABLE.filter((x) =>
            //         x.td1.match(val.target.value)
            //       )
            //     );
            //   }}
            />
            <div className="searchIcon">
              <SearchIcon
                style={{
                  color: "#fff",
                  width: "20",
                  height: "20",
                  margin: "5 5",
                }}
              ></SearchIcon>
            </div>
          </div>
          <div className="supplier-content-input-right">
            <select
              name=""
              id=""
              className="supplier-content-input-right-filters"
            >
              <option value="" selected>
                Quantity
              </option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
            <select
              name=""
              id=""
              className="supplier-content-input-right-filters"
            >
              <option selected>Order Status</option>
              <option value="1">1</option>
              <option value="2">2</option>
              <option value="3">3</option>
              <option value="4">4</option>
            </select>
            <button
              className="supplier-content-input-right-filters"
              style={{ display: "flex", alignItems: "center" }}
            >
              Explore List
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </button>
          </div>
        </div>
        <div className='warehouse-details-box'>
        {data.map((data) => {
            return (
            <div className='warehouse-details-card'>
            <div>
                <div className='warehouse-name'>
                    <h3>
                        {data.name}
                    </h3>
                    <div className='warehouse-active-time'>
                        <p className='warehouse-active-time-p'>Type: <span className='detail-dark' style={{fontSize:'10px'}}>{data.type}</span></p>
                        <p >Active Hours: <span className='detail-dark' style={{fontSize:'10px'}}>{data.timing}</span></p>
                    </div>
                </div>
                <p className='warehouse-location'>Location of the warehouse</p>
            </div>
            <div className='warehouse-card-more-detail'>
                <div className='warehouse-operator'>
                    <p>Warehouse Operator/Manager: <span className='detail-dark'>{data.operator}</span></p>
                    <p className='warehouse-contact'>Contact: <span className='detail-dark'>{data.contact}</span></p>
                    <p>Order Fulfilment Rate: <span className='detail-dark'>{data.rate}</span></p>
                    <button>Edit Warehouse Details</button>
                </div>
                <div style={{marginRight:'5%'}}>
                    <p style={{textAlign:'center', fontWeight:'700', margin:'0 0 20px 20px'}}>Orders</p>
                    <div className='warehouse-orders'>
                        <div className='warehouse-orders-div'>
                            <p>Pending</p>
                            <div className='warehouse-card-pending' style={{backgroundColor:'#ffc0c0'}}>{data.pending}</div>
                        </div>
                        <div className='warehouse-orders-div'>
                            <p>Outgoing</p>
                            <div className='warehouse-card-pending' style={{backgroundColor:'#FFF3A1'}}>{data.outgoing}</div>
                        </div>
                        <div className='warehouse-orders-div'>
                            <p>Delivered</p>
                            <div className='warehouse-card-pending' style={{backgroundColor:'#CCFFC0'}}>{data.delivered}</div>
                        </div>
                        <div className='warehouse-orders-div'>
                            <p>Returned</p>
                            <div className='warehouse-card-pending' style={{backgroundColor:'#AEBBFF'}}>{data.returned}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
            )
        })}
        
        </div>
        </div>
    </div>
  )
}

export default WarehouseDetails
